module.exports = __webpack_public_path__ + "img/team-member-01.a8134d30.jpg";